import {createRecipe, getAllRecipes} from "../../services/RecipeService";
import {useNavigate} from "react-router-dom";
import {useImmer} from "use-immer";
import {createElement, useContext, useState} from "react";
import {classList, inputIsNotEmpty, inputValue, onEnter} from "../../util/util";
import styles from './Create.module.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {AMOUNT, INGREDIENT, PLACEHOLDER, UOM, validateAndFormat} from "./createUtil";

const Title = ({title, setTitle}) => (
    <>
        <h2>Title</h2><br/>
        <input
            id={styles['title']}
            autoFocus
            type='text'
            name='title'
            defaultValue={title}
            placeholder='Title'
            onChange={inputValue(setTitle)}
        />
    </>
)

const Instructions = ({instructions, setInstructions}) => (
    <>
        <h2>Instructions</h2><br/>
        <input
            id={styles['instructions']}
            autoFocus
            type='text'
            name='instructions'
            defaultValue={instructions}
            placeholder='Instructions'
            onChange={inputValue(setInstructions)}
        />
    </>
)

const Ingredient = ({value, update, id, index, className, remove, disableRemove, triggerAdd}) => {
    const units = {
        "OUNCE": "oz",
        "MILLILITER": "ml",
        "TEASPOON": "tsp",
        "TABLESPOON": "tbsp",
        "DASH": "dash",
        "CUP": "cup",
        "GRAM": "g",
        "ITEM": "item"
    }

    const [unit, setUnit] = useState(units["OUNCE"])

    const updateSubValue = (field) => (subValue) => {
        update({
            ...value,
            [field]: subValue
        })
    }

    const updateUOM = (uomValue) => {
        setUnit(() => uomValue)
        updateSubValue(UOM)(uomValue)
    }

    return (
        <div className={styles[className]}>
            <input
                min={0}
                type='number'
                autoFocus={index > 0}
                className={classList(styles.ing, styles.amount)}
                name={`${id}${AMOUNT}`}
                defaultValue={value[AMOUNT]}
                onChange={inputValue(updateSubValue(AMOUNT))}
            />
            <select
                className={classList(styles.ing, styles.uom)}
                name={`${id}${AMOUNT}`}
                onChange={inputValue(updateUOM)}
            >
                {
                    Object.keys(units).map((unitOfMeasure) => (
                        <option key={unitOfMeasure} value={unitOfMeasure}>{units[unitOfMeasure]}</option>
                    ))
                }
            </select>
            <input
                type='text'
                className={classList(styles.ing, styles.name)}
                placeholder={PLACEHOLDER.ING}
                name={`${id}${INGREDIENT}`}
                onChange={inputValue(updateSubValue(INGREDIENT))}
                onKeyDown={onEnter(triggerAdd, inputIsNotEmpty)}
            />
            <RemovalBtn
                remove={remove}
                disabled={disableRemove}
            />
        </div>
    )
}


const RemovalBtn = ({disabled, remove}) => (
    <button
        className={styles.listItemRemoveBtn}
        onClick={remove}
        disabled={disabled}
    >
        <FontAwesomeIcon icon={["far", "circle-x"]} size='2x'/>
    </button>
)

const ListCreation = ({list, updateList, defaultItem, component, classification}) => {
    const updateItem = (key) => (value) => updateList(draft => {
        draft.find((x, i) => i === key).value = value
    })

    const addItem = () => updateList(draft => {
        draft.push({
            key: draft.length,
            value: structuredClone(defaultItem)
        })
    })
    const removeItem = (index) => () => updateList((draft) => {
        draft.splice(index, 1)
    })

    return (
        <div className={styles[`${classification.toLowerCase()}-wrapper`]}>
            <h2>{classification}s</h2>
            <button
                type={"button"}
                className={styles.listItemAddBtn}
                onClick={addItem}
            >
                <FontAwesomeIcon icon={["far", "circle-plus"]} size='2x'/>
            </button>
            {
                list.map((item, index) => (
                    createElement(component, {
                        ...item,
                        index,
                        id: item.key,
                        className: classification.toLowerCase(),
                        update: updateItem(index),
                        remove: removeItem(index),
                        disableRemove: list.length < 2,
                        triggerAdd: addItem
                    })))
            }
        </div>
    )
}

const Create = () => {
    const navigate = useNavigate()
    const [title, setTitle] = useState("")
    const [instructions, setInstructions] = useState("")
    const [errorField, setErrorField] = useState("")

    const defaultIng = {[AMOUNT]: 1, [UOM]: "OUNCE", [INGREDIENT]: ""}
    const [ingList, setIngList] = useImmer([{key: 0, value: structuredClone(defaultIng)}])


    const createCocktail = () => {
        const {error, requestBody} = validateAndFormat(title, instructions, ingList)

        if (error) {
            setErrorField(error)
        } else {
            createRecipe(requestBody).then((res) => {
                navigate(`/`)
            })
        }
    }

    return (
        <form autoComplete={"off"} novalidate>
            <div className={`gutters ${styles.create}`}>
                <Title title={title} setTitle={setTitle}/>
                <Instructions instructions={instructions} setInstructions={setInstructions}/>
                <ListCreation
                    classification='Ingredient'
                    defaultItem={defaultIng}
                    list={ingList}
                    updateList={setIngList}
                    component={Ingredient}
                />
                <div className={styles.submitWrapper}>
                    <br/><br/>
                    <button onClick={createCocktail}>
                        Create
                    </button>
                    <br/>
                    {errorField && <p><em>Error on field: {errorField}</em></p>}
                </div>
            </div>
        </form>
    )
}

export default Create
